export default "__VITE_ASSET__CX7c4$_q__"